module.exports = __webpack_public_path__ + "static/media/cloud-music.a95e7367.svg";